import { FaExclamationCircle, FaCheckCircle } from "react-icons/fa";
import DocImage from "../../images/doc-icons.gif";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaLink } from "react-icons/fa6";

const Notification = () => {
    const [status, setStatus] = useState('success')
    const [role, setRole] = useState('');
    const [fileName, setFileName] = useState('');
    const [journalCode, setJournalCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [device, setDevice] = useState('');

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setStatus(location?.state?.status);
        setErrorMessage(location?.state?.Message);
        setRole(location?.state?.role);
        setFileName(location?.state?.filename);
        setJournalCode(location?.state?.journalcode);
        setDevice(location?.state?.device);
        if (location?.state?.filename) {
            let Code = removePrefix(location?.state?.filename, location?.state?.journalcode);
            setFileName(Code);
        }
    }, [location])


    function removePrefix(value, jid) {
        return value.startsWith(jid) ? value.substring(jid.length) : value;
    }

    // useEffect(() => {

    //     if (location?.state?.status === 'sucess' && location?.state?.role === 'author') {
    //         return;
    //     }

    //     if (location?.state?.status === 'error' ) {
    //         // Check if the sessionStorage flag is set
    //         const isRefreshed = sessionStorage.getItem('isRefreshed');
    //         if (isRefreshed) {
    //             // Clear the flag to avoid triggering again
    //             sessionStorage.removeItem('isRefreshed');
    //             navigate(`/editor${location.search}`)
    //         } else {
    //             // Set the flag for the first time
    //             sessionStorage.setItem('isRefreshed', 'true');
    //         }
    //     }
    //     // }
    // }, [navigate,location]);

    useEffect(() => {
        const { status, role } = location?.state || {};

        // Condition where we do NOT refresh
        if (status === "success" && role === "Author") {
            return;
        }

        // Conditions where we need to refresh
        if (
            (status === "error" && role === undefined) ||
            (status === "error" && role === "Author") ||
            (status === "success" && role !== "Author")
        ) {
            const isRefreshed = sessionStorage.getItem('isRefreshed');

            if (isRefreshed) {
                sessionStorage.removeItem('isRefreshed');
                navigate(`/editor${location.search}`);
            } else {
                sessionStorage.setItem('isRefreshed', 'true');
            }
        }
    }, [navigate, location]); // Ensure dependencies are added


    // useEffect(() => {

    //     let timer;
    //     if (status !== 'error') {
    //         timer = setInterval(() => {
    //             setCountdown(prevCountdown => {
    //                 if (prevCountdown <= 1) {
    //                     clearInterval(timer);
    //                     window.location.href = 'https://www.surveymonkey.com/r/HMBCDK5?JID=ELS&AID=33BAF209';
    //                     return 0;
    //                 }
    //                 return prevCountdown - 1;
    //             });
    //         }, 1000);
    //     }
    //     return () => clearInterval(timer);
    // }, [status]);

    function closeCurrentTab() {
        // Close the current tab
        window.close();
    }

    return (
        <div className="notification">
            <div className="notification-inner">
                <div className="notification-img">
                    <img src={DocImage} alt="doc" />
                    {status === 'error' || device === 'mobile' ? <FaExclamationCircle className="error" /> : <FaCheckCircle className="success" />}
                </div>
                {device === 'mobile' ?
                    <h2>This application is not supported on mobile devices. Please use a desktop.</h2>
                    :
                    <>
                        <h2>{status === 'error' ? 'An unexpected exception occurred.' : 'The document has been saved and submitted successfully.'}</h2>
                        <p>{errorMessage?.length !== '' ? errorMessage : ''}</p>
                        {/* {status !== 'error' && <h5>Will navigate to the survey in {countdown} sec</h5>} */}
                        {status !== 'error' ?
                            <>
                                <p>Thank you for returning your proof corrections. We would value your feedback on your proofing experience.</p>
                                {role === "Author" ? <a href={`https://www.surveymonkey.com/r/HMBCDK5?JID=${journalCode}&AID=${fileName}`}><FaLink /> https://www.surveymonkey.com/r/HMBCDK5?JID={journalCode}&AID={fileName}</a> : ""}
                                <br></br>
                                <Button variant="primary" style={{ margin: '10px 0', fontSize: '13px' }} onClick={() => closeCurrentTab()}>{role === "Author" ? 'Skip and Close' : 'Close'}</Button>
                            </> :
                            <>
                                <p>Please contact our support team in case of any assistance.</p>
                                <p className="support">By email : <a href="mailto:product.support@integra.co.in">product.support@integra.co.in</a></p>
                            </>
                        }
                    </>
                }
            </div>
        </div>
    )
}
export default Notification;
